<template>
  <div class="productTableHeader">
    <ProductTable
      :headers="recDetail.productListHeaders"
      :items="recItems.productMoves"
      item-key="product.productNumber"
      productKey="productMoveId"
      :tableKey="type + 'Id'"
    >
      <template v-slot:price="{ item }">
        {{
          isOrder
            ? maskText(
                formatPrice(Number(item.price)).toLocaleString() +
                  getCurrencyName(item),
                authority.isAdmin || authority.isUser
              )
            : formatPrice(Number(item.price)).toLocaleString() +
              getCurrencyName(item)
        }}
      </template>
    </ProductTable>
    <div
      v-if="isTotalAmount"
      class="py-3"
      :class="{
        'pl-4': isEdit,
        'pl-16': !isEdit
      }"
    >
      <TotalAmount
        v-model="totalList"
        v-if="!isOrder || (isOrder && (authority.isAdmin || authority.isUser))"
      >
        <template #button>
          <slot name="button" />
        </template>
      </TotalAmount>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { productMovesUtil, saleUtil, orderUtil, commonUtil } from '@/util'

import TotalAmount from '@/components/items/Designs/TotalAmount/TotalAmount'
import { ProductTable } from '@/components/items'
import saleHeadersHistory from '@/views/sales/History/headers'
import orderHeadersHistory from '@/views/order/History/headers'
import { currencyUtil } from '@/util'

export default {
  components: {
    ProductTable,
    TotalAmount
  },
  props: {
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    },
    type: {
      type: String,
      require: true,
      default: () => ''
    },
    isEdit: { default: false },
    isTotalAmount: { default: true }
  },
  data: () => ({
    recDetail: {
      productListHeaders: []
    },

    totalList: {
      taxFree: 0,
      tax10: {
        totalAmount: 0,
        tax: 0
      },
      tax8: {
        totalAmount: 0,
        tax: 0
      },
      discount: 0,
      shipping: 0,
      totalAmount: 0,
      unitName: ''
    }
  }),
  created() {
    this.ini()
  },
  methods: {
    getObjectByType() {
      switch (this.type) {
        case 'order':
          return [orderUtil, orderHeadersHistory]
        case 'sale':
          return [saleUtil, saleHeadersHistory]
      }
    },

    ini() {
      const [operationUtil, historyHeaders] = this.getObjectByType()
      this.recDetail.productListHeaders = this.isEdit
        ? historyHeaders.productListHeadersForEdit
        : historyHeaders.productListHeaders

      // 発注で履歴に設定された通貨が日本円の場合は各消費税の小計に加える
      let totalAmountAndUnitTaxFree = 0
      if (this.isOrder && !this.isCurrencyJpn) {
        totalAmountAndUnitTaxFree = totalAmountAndUnitTaxFree =
          productMovesUtil.getTotalAmountAndUnit(
            this.recItems.productMoves,
            this.recItems.currencyId
          )
      } else {
        totalAmountAndUnitTaxFree = productMovesUtil.getTotalAmountAndUnit(
          this.recItems.productMoves.filter((ele) => ele.exportSubjectFlg),
          this.recItems.currencyId
        )
      }

      let totalAmountTax10 = 0
      let totalAmountTax8 = 0
      if (this.isOrder && this.isCurrencyJpn) {
        totalAmountTax10 = productMovesUtil.getTotalAmount(
          this.recItems.productMoves.filter((ele) => ele.product.taxId === 2)
        )
        totalAmountTax8 = productMovesUtil.getTotalAmount(
          this.recItems.productMoves.filter((ele) => ele.product.taxId === 1)
        )
      } else if (!this.isOrder) {
        totalAmountTax10 = productMovesUtil.getTotalAmount(
          this.recItems.productMoves.filter(
            (ele) => !ele.exportSubjectFlg && ele.product.taxId === 2
          )
        )
        totalAmountTax8 = productMovesUtil.getTotalAmount(
          this.recItems.productMoves.filter(
            (ele) => !ele.exportSubjectFlg && ele.product.taxId === 1
          )
        )
      }
      const totalAmountTax10OnlyTax = this.recItems.consumptionTax10
      const totalAmountTax8OnlyTax = this.recItems.consumptionTax8

      if (this.isTotalAmount) {
        const totalAmount = operationUtil[
          `calc${this.type.charAt(0).toUpperCase()}${this.type.slice(
            1
          )}AmountById`
        ](this.recItems[`${this.type}Id`])

        this.totalList = {
          taxFree: totalAmountAndUnitTaxFree.amount,
          tax10: {
            totalAmount: totalAmountTax10,
            tax: totalAmountTax10OnlyTax
          },
          tax8: {
            totalAmount: totalAmountTax8,
            tax: totalAmountTax8OnlyTax
          },
          discount: this.recItems.discount,
          shipping: this.recItems.comission,
          totalAmount: totalAmount,
          unitName: totalAmountAndUnitTaxFree.unit,
          currencyId: this.recItems.currencyId
        }
      }
    },
    getCurrencyName(productInfo) {
      const currencyId = productInfo.currencyId
      if (currencyId) {
        return currencyUtil.findCurrencyNameById(currencyId).unitName
      }
      return ''
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    isOrder() {
      return this.type === 'order'
    },
    isCurrencyJpn() {
      return this.recItems.currencyId === 1
    }
  }
}
</script>
<style scoped lang="scss">
.productTableHeader {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1) !important;
    padding: 0 !important;
  }
}
.totalAmountStyle {
  width: 100%;
  margin: auto;
}
</style>
